import { PopupRequestService } from './popup-request.service';

export default angular
  .module('sfMobile.services.popup-request', ['sfMobile.services.popup'])
  .factory('popupRequestService', PopupRequestService).name;
